import { AttachmentTypeEnum } from '@models/enums/attachment-type-enum';
import { ContactTypeEnum } from '@models/enums/contact-type-enum';
import { DocumentTypeEnum } from '@models/enums/document-type-enum';
import { MessageErrorResolver } from 'src/app/core/utilities/message-error-resolver';
import {
  userAddressFieldReference,
  userBasicDataFieldReference,
} from '../requitred-fields-config';

const BASIC_DATA_FIELDS = [
  'usuTxNome',
  'usuTxSexo',
  'usuDtNascimento',
  'usuTxTipoSanguineo',
  'usuTxLadoDominante',
  'usuNrPeso',
  'usuNrAltura',
  'usuTxCodigoInep',
  'fedNrId',
  'insNrId',
  'carNrId',
  'usuBlAuxilioBrasil',
] as const;

const ADDRESS_FIELDS = [
  'logTxCep',
  'paiNrId',
  'estNrId',
  'cidNrId',
  'logTxLogradouro',
  'logNrNumero',
  'logTxBairro',
  'logTxComplemento',
] as const;

/** Registra mapeamentos formKey → label da API para o clone do MessageErrorResolver. */
export function registerUserFormApiErrorParams(
  resolver: MessageErrorResolver,
): void {
  BASIC_DATA_FIELDS.forEach((field) => resolver.setupParam(field, field));
  ADDRESS_FIELDS.forEach((field) => resolver.setupParam(field, field));

  resolver.setupParam('usuBlTermoDeUso', 'usuBlTermoDeUso');

  resolver.setupParam('banNrId', 'banNrId');
  resolver.setupParam('ageNrId', 'ageNrId');
  resolver.setupParam('cobTxNumeroConta', 'cobTxNumeroConta');
  resolver.setupParam('cobTxTipoConta', 'cobTxTipoConta');

  resolver.setupParam('ureTxParentesco', 'ureTxParentesco');

  resolver.setupParam('docTxDocumento', 'docTxDocumento');
  Object.values(DocumentTypeEnum).forEach((tipo) => {
    resolver.setupParam(`${tipo}_docTxDocumento`, tipo);
  });
  resolver.setupParam('docTxOrgaoExpeditor', 'docTxOrgaoExpeditor');

  Object.values(ContactTypeEnum).forEach((tipo) => {
    resolver.setupParam(`${tipo}_conTxContato`, tipo);
  });
  resolver.setupParam('conTxContato', 'conTxContato');
  resolver.setupParam('conTxTipo', 'conTxTipo');

  Object.values(AttachmentTypeEnum).forEach((tipo) => {
    resolver.setupParam(`${tipo}_aneBtAnexo`, tipo);
  });
  resolver.setupParam('aneBtAnexo', 'aneBtAnexo');

  Object.values(userBasicDataFieldReference).forEach((field) => {
    resolver.setupParam(field, field);
  });
  Object.values(userAddressFieldReference).forEach((field) => {
    resolver.setupParam(field, field);
  });
}
